import { MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import Slider from "dependencies/carousel"

const SliderWrapper = styled(Slider)`
  button[aria-label="next"],
  button[aria-label="previous"] {
    top: ${(props) =>
      props.arrowAdjust ? `calc(50% - ${props.arrowAdjust})` : "50%"};
  }

  ${(props) => props.theme.mediaQueries.tablet`
    .slider-control-centerleft {
      margin-left: ${
        props.arrowPlacement === "outside" ? 0 : props.arrowPlacement
      };
    }
    .slider-control-centerright {
      margin-right: ${
        props.arrowPlacement === "outside" ? 0 : props.arrowPlacement
      };
    }
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    .slider-control-centerleft {
      margin-left: ${
        props.arrowPlacement === "outside" ? "-10px" : props.arrowPlacement
      };
    }
    .slider-control-centerright {
      margin-right: ${
        props.arrowPlacement === "outside" ? "-10px" : props.arrowPlacement
      };
    }
  `}
`

const ArrowImg = styled.img`
  margin: 0 auto;
  position: relative;
`

const Arrow = ({ arrowAdjust, next }) => {
  return (
    <ArrowImg
      alt={`Go to ${next ? "next" : "previous"} review`}
      arrowAdjust={arrowAdjust}
      className="lazyload"
      data-src={require("images/icons/arrow_left_dark.svg")}
      src={require("images/icons/jewlr.gif")}
      width="15"
    />
  )
}

Arrow.propTypes = {
  arrowAdjust: PropTypes.string,
  next: PropTypes.bool,
}

const ImagesSlider = ({
  arrowAdjust,
  arrowPlacement,
  children,
  sliderRef,
  ...sliderSettingProps
}) => {
  const swipeable = Modernizr.touchevents
  const sliderSettings = {
    arrowAdjust,
    arrowPlacement: arrowPlacement || "inside",
    defaultControlsConfig: {
      nextButtonText: <Arrow arrowAdjust={arrowAdjust} next />,
      prevButtonText: <Arrow arrowAdjust={arrowAdjust} />,
    },
    dots: false,
    dragging: swipeable,
    swiping: swipeable,
    ...sliderSettingProps,
  }

  return (
    <>
      <MediaBox lessThan="tablet">
        <SliderWrapper {...sliderSettings} ref={sliderRef}>
          {children}
        </SliderWrapper>
      </MediaBox>
      <MediaBox greaterThanOrEqual="tablet">
        <SliderWrapper {...sliderSettings} ref={sliderRef}>
          {children}
        </SliderWrapper>
      </MediaBox>
    </>
  )
}

ImagesSlider.propTypes = {
  arrowAdjust: PropTypes.string,
  arrowPlacement: PropTypes.string,
  children: PropTypes.array.isRequired,
  sliderRef: PropTypes.object,
  sliderSettings: PropTypes.object,
}

export default ImagesSlider
